export default __webpack_public_path__ + "static/media/Banner-image-1.7a702b00.jpg";